<template>
  <div class="nav">
    <h3 class="iconfont icon-ziyuan">啤酒旅行社后台</h3>
        <!-- 没有儿子 -->
    <el-menu router background-color='#2b3a4d' text-color='#fff' :default-active="curActive">
     <template v-for="menu in menus">
        <el-menu-item
         v-if="menu.children && menu.children.length === 0 "
          :index="menu.url"
          :key="menu.url"
          
        >
          <i class="iconfont" :class="menu.icon"></i>
          <span slot="title">{{menu.text}}</span>
        </el-menu-item>

        <!-- 有儿子 -->
        <el-submenu v-else :index="menu.url" :key="menu.url">
          <template slot="title">
            <i class="iconfont" :class="menu.icon"></i>
            <span>{{menu.text}}</span>
          </template>
          <el-menu-item 
          v-for="item in menu.children"
           :key="item.url"          
           :index="item.url"
          >{{item.text}}</el-menu-item>
        
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import local from "@/utils/local";
import {infoNav} from "@/api/api"
export default {
  data() {
    return {
      menus: [],
    };
  },
    computed: {
    // 当前激活
    curActive() {
      return this.$route.path;
      
    },
  },
  created() {
    // this.menus = local.get("menus");
    this.id = local.get("id");
    this.getList()
    
  },
  methods: {
     async getList(){
       let res=await infoNav({
         adminId:this.id
       })
       this.menus=res.data
      //  console.log(res)
      //  console.log(this.menus)
     }
  },
};
</script>

<style lang="less" scoped>
.nav {
  height: 100%;
  flex: 0 0 200px;
  background: #2b3a4d;
  .el-menu {
    border-right: 0px;
    span {
      margin-left: 10px;
    }
  }
  h3 {
    color: #fff;
    margin: 10px 10px 10px 20px;
    font-size: 20px;
  }

  .icon-ziyuan:before {
    display: inline-block;
    background: cornflowerblue;
    color: black;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>